/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';

import {AppBar, Snackbar, Typography, IconButton, Toolbar, Menu, MenuItem} from '@mui/material';
import MuiAlert from '@mui/material/Alert';

import { makeStyles } from '@material-ui/core/styles';

import { AppContext } from './stores/AppStore'
import { UserContext } from './stores/UserStore'


import LogoImg from './assets/images/logo.svg';

const useStyles = makeStyles((theme) => ({
    logoButton: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(3),
        width: '131px',
        height: '45px',
        cursor: 'pointer'
    },
    title: {
        flexGrow: 1,
        color: '#5a5a5aa3',
        fontWeight: 'bold'
    },
    section: {
        display: 'flex'
    },
    userButton: {
        fontSize: 16,
        fontWeight: 600
    }
}));


const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Header = () => {
    const classes = useStyles();
   
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const isMenuOpen = Boolean(anchorEl);

    const { applicationMessage, setApplicationMessage } = useContext(AppContext);
    const { currentUser, signOut, refreshSession } = useContext(UserContext);

    useEffect(() =>  {
        if (applicationMessage && applicationMessage.message && (applicationMessage.message.indexOf('Invalid Security Token') !== -1 || applicationMessage.message.indexOf('Unauthorized') !== -1)) {
            signOut();  
        } else
        if (applicationMessage && applicationMessage.message && applicationMessage.message.indexOf('Token Expired') !== -1) {
            refreshSession();  
        }
    }, [applicationMessage]);
           
    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleCloseMessage = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setApplicationMessage(null);
    };


    return (
        <>   
            <AppBar position="static" color="transparent">
                <Toolbar variant="dense">
                    <img src={LogoImg} className={classes.logoButton} alt="Logo"/>
                    <Typography variant="h5" className={classes.title}>
                        Click'n Quote
                    </Typography>

                    <div className={classes.section}>
                        <IconButton
                            edge="end"
                            aria-label="Account of Current User"
                            aria-controls="user-account-menu"
                            aria-haspopup="true"
                            onClick={handleOpenMenu}
                            className={classes.userButton}>
                            {currentUser ? currentUser.firstName.substring(0,1) + '. ' + currentUser.lastName : ''}
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>

            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                id="user-account-menu"
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={isMenuOpen}
                onClose={handleCloseMenu}
                >
                <MenuItem onClick={handleCloseMenu}>{currentUser && currentUser.firstName + ' ' + currentUser.lastName}</MenuItem>
                <MenuItem onClick={signOut}>SignOut</MenuItem>
            </Menu>

            <Snackbar open={applicationMessage ? true : false} autoHideDuration={6000} onClose={handleCloseMessage} anchorOrigin={{vertical: 'top', horizontal: 'center'} } sx={{ width: '50%' }} >
                { applicationMessage && <div><Alert onClose={handleCloseMessage} severity={applicationMessage.type} sx={{ width: '100%', color: '#fff' }}>
                    {applicationMessage.message}
                </Alert></div> }
            </Snackbar> 
        </>
    )
};

export default Header;
